import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RejectRefundModal = ({ isOpen, refund, onClose, onConfirm }) => {
  if (!isOpen || !refund) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-background/80 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-md bg-card rounded-xl elevation-2xl overflow-hidden border border-border">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-destructive/20">
              <Icon name="XCircle" size={24} className="text-destructive" />
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-heading font-semibold text-foreground mb-2">
                Reject Refund
              </h2>
              <p className="text-sm text-muted-foreground font-body">
                Reject refund request of <span className="font-semibold text-foreground">₹{refund?.refundAmount?.toLocaleString()}</span> from <span className="font-semibold text-foreground">{refund?.clientName}</span>?
              </p>
            </div>
          </div>

          <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md mb-6">
            <div className="flex items-start gap-2">
              <Icon name="AlertCircle" size={16} className="text-destructive flex-shrink-0 mt-0.5" />
              <div className="space-y-1">
                <p className="text-sm font-medium text-destructive font-body">
                  Client will be notified of rejection
                </p>
                <p className="text-xs text-muted-foreground font-caption">
                  Reason: {refund?.reason}
                </p>
              </div>
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              type="button"
              variant="outline"
              size="lg"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="destructive"
              size="lg"
              onClick={onConfirm}
              iconName="XCircle"
              iconPosition="left"
              fullWidth
            >
              Reject
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectRefundModal;